import { CSSProperties } from 'react';
import { antGrey, statusElement } from './globalStyles';

const releaseItem = {
    minMarginLeft: 6,
    minMarginRigth: 6,
};

const styles = {
    timelineStyle: {
        backgroundColor: antGrey.grey10,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        height: '100%',
        borderRightColor: antGrey.grey5,
        borderRightWidth: 1,
        borderRightStyle: 'solid',
        justifyContent: 'space-between',
    } as CSSProperties,
    timelineHeaderStyle: {
        paddingLeft: 20,
        paddingRight: 10,
        paddingTop: 16,
        paddingBottom: 10,
    } as CSSProperties,
    timelineContent: {
        paddingLeft: 18,
        paddingRight: 18,
    } as CSSProperties,
    mainTimeline: {
        padding: 6,
    } as CSSProperties,
    timelineList: {
        listStyleType: 'none',
    } as CSSProperties,
    status: {
        ...statusElement,
    } as CSSProperties,
    releaseContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    } as CSSProperties,
    releaseVersion: {
        ...releaseItem,
        marginLeft: 12,
        marginRight: 12,
    } as CSSProperties,
    releaseCreatedAt: {
        ...releaseItem,
    } as CSSProperties,
    navigationContainer: {
        height: 30,
        width: 30,
    } as CSSProperties,
};

export default styles;
